import { ArrowForward } from "@mui/icons-material";
import { Button } from "@mui/material";

const ForwardButton = (props) => (
  <Button
    variant="contained"
    endIcon={<ArrowForward />}
    sx={{ marginLeft: 2 }}
    {...props}
  >
    {props.label || "CONTINUE"}
  </Button>
);

export default ForwardButton;
